// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nm1p","footer":"styles_footer__3Z2zm"};